module.exports = __webpack_public_path__ + "images/michael_zargham.jpg?v=1d562412fc30cc444936faebaa64312f";